import { environments } from './environments';

// reads from the key from the env variable REACT_APP_ENV
// React requires us to name env variables with 'REACT_APP' prefix
const selectedEnv = process.env.REACT_APP_ENV || 'dev1';
const environment = environments[selectedEnv];

export default environment;
